<template>
  <div class="service-widget service-list-area">
    <h4 class="sidebar-title">{{ title }}</h4>
    <ul class="service-list">
      <li
        v-for="(item, index) in items"
        :key="index"
        :class="activeIndex == index ? 'active' : ''"
        @click="handleTabChange(index)"
      >
        <router-link :to="item.path">{{ item.name }}</router-link>
        <svg
          width="20"
          height="16"
          viewBox="0 0 20 16"
          xmlns="http://www.w3.org/2000/svg"
          :style="activeIndex == index ? 'fill:#fff' : ''"
        >
          <path
            d="M12.7496 15.4594C12.4954 15.4594 12.2385 15.41 11.9928 15.3082C11.2572 15.0038 10.7819 14.2953 10.7819 13.5034V11.8225C10.7819 11.3909 11.1316 11.0411 11.5631 11.0411C11.9946 11.0411 12.3445 11.3909 12.3445 11.8225V13.5034C12.3445 13.7374 12.5165 13.8337 12.5903 13.8644C12.6656 13.8955 12.8587 13.9497 13.0272 13.7811L18.2094 8.59248C18.5147 8.28685 18.5147 7.78956 18.2094 7.48393L13.0272 2.29548C12.8587 2.12687 12.6656 2.18088 12.5905 2.21201C12.5165 2.24268 12.3445 2.33912 12.3445 2.57319V7.29594C12.3445 8.1576 11.6435 8.85859 10.7819 8.85859H0.781251C0.349732 8.85859 0 8.50886 0 8.07734C0 7.64582 0.349732 7.29594 0.781251 7.29594H10.7819V2.57319C10.7819 1.78126 11.2572 1.07264 11.9928 0.768223C12.731 0.462742 13.571 0.628758 14.1327 1.1912L19.3149 6.37965C20.2283 7.29426 20.2283 8.7823 19.3149 9.69691L14.1327 14.8854C13.7579 15.2606 13.2593 15.4592 12.7496 15.4594Z"
          />
        </svg>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "ServiceList",
  props: {
    title: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    activeIndex: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    handleTabChange(index) {
      this.$emit("tab-change", index);
    },
  },
};
</script>

<style scoped>
@import url("../assets/css/style.css");
.active {
  background-color: var(--primary-color1);
  fill: var(--white);
}
.active a {
  color: var(--white) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ServiceList.vue